import { createContext, PropsWithChildren, useState } from "react";

type ApiContextType = {
	data: any;
	setData: (value: any) => void;
};

/**
 * Context for Api response data.
 */
export const ApiContext = createContext<ApiContextType>({
	data: {},
	// eslint-disable-next-line
	setData: (data) => {},
});

/**
 * Provider.
 */
export const ApiContextProvider = ({ children }: PropsWithChildren) => {
	const [data, setData] = useState({});

	return (
		<ApiContext.Provider value={{ data, setData }}>
			{children}
		</ApiContext.Provider>
	);
};
